
import { defineComponent } from "vue";
import TokenCard from "@/common/components/TokenCard.vue";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/vue/outline";

export default defineComponent({
  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
    TokenCard,
  },
  props: ["tokens"],
  setup() {
    return {};
  },
});
